import { Injectable, NgZone } from "@angular/core";
import { BehaviorSubject, fromEvent, merge } from "rxjs";

@Injectable({ providedIn: "root" })
export class IdleService {
  private timeoutMs = 30 * 60 * 1000; // 30 minutes
  private endTime!: number;
  private intervalId: any;

  private remainingTime$ = new BehaviorSubject<string>("30:00");
  constructor(private ngZone: NgZone) {}

  startWatching(onTimeout: () => void) {
    this.resetTimer();

    this.ngZone.runOutsideAngular(() => {
      const activity$ = merge(
        fromEvent(document, "mousemove"),
        fromEvent(document, "keydown"),
        fromEvent(document, "click"),
        fromEvent(document, "scroll"),
      );

      // Reset ONLY when activity happens in THIS TAB
      activity$.subscribe(() => {
        if (!document.hidden) {
          this.resetTimer();
        }
      });

      // Detect tab visibility change
      fromEvent(document, "visibilitychange").subscribe(() => {
        if (!document.hidden) {
          // When user comes back to tab, re-check timeout immediately
          this.checkTimeout(onTimeout);
        }
      });

      this.intervalId = setInterval(() => {
        this.checkTimeout(onTimeout);
      }, 1000);
    });
  }

  private checkTimeout(onTimeout: () => void) {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.intervalId);
      this.ngZone.run(() => onTimeout());
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;

    const formatted =
      mins.toString().padStart(2, "0") + ":" + secs.toString().padStart(2, "0");

    this.ngZone.run(() => {
      this.remainingTime$.next(formatted);
    });
  }

  resetTimer() {
    this.endTime = Date.now() + this.timeoutMs;
  }

  stopWatching() {
    clearInterval(this.intervalId);
  }
}
